import { isShowcase } from './showcase'
import { showShowcaseNotice } from './ShowcaseNotice'

/**
 * One gate for every order-mutating tap in showcase mode.
 *
 * Round 3 seeded real-looking rewards, offers and saved addresses, which makes
 * taps reachable that used to hit empty lists. In showcase those taps must show
 * the book-a-call nudge instead of mutating a cart or firing network — the same
 * contract MenuPage's add-to-order has had since round 1.
 *
 * Returns true when the caller must return early.
 */
export function showcaseBlocked(): boolean {
  if (!isShowcase()) return false
  showShowcaseNotice()
  return true
}
